<template>
  <div>
    <router-view class="min-h-screen" />
  </div>
</template>

<script>

export default {
}
</script>
